const genCollapseMotion = (token) => {
    const { componentCls, antCls, motionDurationMid, motionEaseInOut } = token;
    return {
        [componentCls]: {
            [`${antCls}-motion-collapse`]: {
                overflow: 'hidden',
                transition: `${['height', 'opacity']
                    .map((prop) => `${prop} ${motionDurationMid} ${motionEaseInOut}`)
                    .join(', ')} !important`,
            },
        },
    };
};
export default genCollapseMotion;
